import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getAddresses = async (searchString) => {
  const data = await request.get(
    `/RentPlace/address/house`,
    {
      searchString,
    },
    'При загрузке адресов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useAddresses = (search) =>
  useQuery([queries.addresses, search], () => getAddresses(search), {
    placeholderData: [],
  });

export default useAddresses;
